import { useEffect } from 'react';
import type { StepId } from '../../types';

export const useStepFocus = (currentStepId: StepId): void => {
  useEffect(() => {
    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
    } catch {
      window.scrollTo(0, 0);
    }
    requestAnimationFrame(() => {
      const h1 = document.querySelector('.step-content h1') as HTMLElement | null;
      if (h1) {
        if (!h1.hasAttribute('tabindex')) {
          h1.setAttribute('tabindex', '-1');
        }
        h1.focus({ preventScroll: true });
      }
    });
  }, [currentStepId]);
};
